import { memo, useMemo } from "react";

import { RenderResourceRowCellProps } from ".";
import IacManagementTableVendorCell from "../components/VendorCell";
import IacManagementResourceCell from "../components/ResourceCell";
import useCellFilterAction from "../useCellFilterAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import { getIacManagementStackVendorMeta } from "../../helpers";

const IacManagementTableResourceRowCellVendor = memo((props: RenderResourceRowCellProps) => {
  const { row } = props;

  const vendorMeta = getIacManagementStackVendorMeta(row.stackVendor);

  const vendorFilterAction = useCellFilterAction(
    ResourcesSuggestions.Vendor,
    vendorMeta?.text || ""
  );

  const actions = useMemo(
    () => (vendorMeta ? [vendorFilterAction] : []),
    [vendorMeta, vendorFilterAction]
  );

  return (
    <IacManagementResourceCell {...props} actions={actions}>
      <IacManagementTableVendorCell vendorMeta={vendorMeta} />
    </IacManagementResourceCell>
  );
});

IacManagementTableResourceRowCellVendor.displayName = "IacManagementTableResourceRowCellVendor";

export default IacManagementTableResourceRowCellVendor;
